import { t } from "@travily/i18n";
import { Select } from "@ui/components/Select";
import { LANGUAGE_OPTIONS, type LanguageCode } from "../../../filter-values";
import LanguageIcon from "./language.svg?react";

export type { LanguageCode };

export interface LanguageFilterProps {
  onChange: (codes: LanguageCode[]) => void;
  value: LanguageCode[];
}

export function LanguageFilter({ onChange, value }: LanguageFilterProps) {
  // i18n-tasks-use t('common.languages.ar')
  // i18n-tasks-use t('common.languages.cs')
  // i18n-tasks-use t('common.languages.da')
  // i18n-tasks-use t('common.languages.de')
  // i18n-tasks-use t('common.languages.el')
  // i18n-tasks-use t('common.languages.en')
  // i18n-tasks-use t('common.languages.es')
  // i18n-tasks-use t('common.languages.fi')
  // i18n-tasks-use t('common.languages.fr')
  // i18n-tasks-use t('common.languages.hi')
  // i18n-tasks-use t('common.languages.hu')
  // i18n-tasks-use t('common.languages.id')
  // i18n-tasks-use t('common.languages.it')
  // i18n-tasks-use t('common.languages.ja')
  // i18n-tasks-use t('common.languages.ko')
  // i18n-tasks-use t('common.languages.nl')
  // i18n-tasks-use t('common.languages.no')
  // i18n-tasks-use t('common.languages.pl')
  // i18n-tasks-use t('common.languages.pt')
  // i18n-tasks-use t('common.languages.ru')
  // i18n-tasks-use t('common.languages.sv')
  // i18n-tasks-use t('common.languages.th')
  // i18n-tasks-use t('common.languages.tr')
  // i18n-tasks-use t('common.languages.vi')
  // i18n-tasks-use t('common.languages.zh')

  return (
    <Select
      aria-label={t("components.views.destinations.search.language_label")}
      leadIcon={<LanguageIcon />}
      onChange={(keys) => onChange(keys as LanguageCode[])}
      placeholder={t("components.views.destinations.search.language_placeholder")}
      selectionMode="multiple"
      size="lg"
      value={value}
    >
      {LANGUAGE_OPTIONS.map((code) => (
        <Select.Item id={code} key={code}>
          {t(`common.languages.${code}`)}
        </Select.Item>
      ))}
    </Select>
  );
}
